import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getInventoryById } from 'src/redux/slices/kitchen';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import KitchenNewEditForm from '../kitchen-new-edit-form';
import { LoadingScreen } from '../../../components/loading-screen';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';

type Props = {
  id: string;
};

export default function KitchenEditView({ id }: Props) {
  const { item, status, error } = useAppSelector((state) => state.inventory);

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getInventoryById({ itemID: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load kitchen item details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.kitchen.root()}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Kitchen
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Edit Kitchen Item"
        links={[
          {
            name: 'Kitchen',
            href: paths.dashboard.kitchen.root(),
          },
          { name: 'Edit Kitchen Item' },
        ]}
        sx={{
          mb: { xs: 3, md: 5 },
        }}
      />

      <KitchenNewEditForm currentKitchenItem={item} />
    </Container>
  );
}
